/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

async function getDiscount() {
  var discountInfoUrl = "/apps/discountz-api-new/discount-info"
  let cookie = '';
  if (!!getCookie("discount_code")) {
    cookie = getCookie("discount_code")
  }else {
    if (!!getCookie("voucher_form_submitted")) {
      cookie = getCookie("voucher_form_submitted")
    }
  }

  if (cookie && cookie !== "") {
    const discountCodeInfo = await fetch(discountInfoUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code: cookie}),
    })
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => console.error);
    if (discountCodeInfo.status === "ACTIVE") {
      setCookie("discount_response", true, 365)
      return discountCodeInfo
    }else {
      setCookie("discount_response", false, 365)
      return false
    }
  }else {
    setCookie("discount_response", false, 365)
    return false
  }
}

function checkGoldClubCookie() {
  return getDiscount().then(function (cookie) {
    if (!!cookie && cookie.code && cookie.code.substring(0, 2).toLowerCase() === "gc") {
      return true;
    }
    return false;
  });
}
// This function checks for the gourmet section && hide / show if its present
var heroSection = document.querySelector('[id="$hero-section__gc-function"]');
var heroSectionGourmetClub = document.querySelector('[id="$hero-gourmet-section__gc-function"]');
var main = document.getElementById('main');
  $(document).ready(function () {
    checkGoldClubCookie().then(function (cookie) {
      if(heroSectionGourmetClub != null){ 
        if (cookie === true) {
            if(heroSection != null) {
            heroSection.classList.add('hidden')
            heroSectionGourmetClub.classList.remove('hidden')
          } 
        }  else {
          heroSectionGourmetClub.classList.add('hidden')
          heroSection.classList.remove('hidden')
        }
      }
      if (cookie === true) {
        main.classList.add('gourmet-club__enabled')
      } else {
        main.classList.remove('gourmet-club__enabled')
      }
    }) 
  })



function getDiscountSession() {
  var discount = sessionStorage.getItem("discount");
  if (typeof discount === "string" && discount.length && discount !== "FALSE") {
    return discount;
  }
  return false;
}


function setDiscountSession(value) {
  sessionStorage.setItem("discount", value ? value : "FALSE");
}

/**
 * Switches out product prices for gold club members
 */
function switchGoldClubPricing() {
  checkGoldClubCookie().then(function (cookie) {
    if (cookie) {
      if(window.theme.template != 'cart'){
        updateMiniCartDiscount();
      }
     
      $(".cart-toggle-price__gold-club").css("display", "");
      $(".toggle-normal-item__price").css("text-decoration", "line-through");
      $(".cart-toggle-price__normal").css("display", "none");
      $(".cart-toggle-tag__gold_club").css("display", "");
      $(".toggle-price__gold-club").css("display", "");
      $(".toggle-price__normal").css("display", "none");
      $(".toggle-product-label-savings-gold-club").css("display", "");
      $(".toggle-compare_at_price-gold-club").css("display", "none");
      $(".toggle-product-label-savings-normal").css("display", "none");
      $(".toggle-product-item__label-gold").css("display", "");
      $('.product-card__redesign').attr('data-gourmet-club', 'true');
      
    } else {
      if(window.theme.template != 'cart'){
        updateMiniCartDiscount();
      }
      $(".cart-toggle-price__gold-club").css("display", "none");
      $(".toggle-normal-item__price").css("text-decoration", "none");
      $(".cart-toggle-price__normal").css("display", "");
      $(".cart-toggle-tag__gold_club").css("display", "none");
      $(".toggle-price__gold-club").css("display", "none");
      $(".toggle-price__normal").css("display", "");
      $(".toggle-product-label-savings-gold-club").css("display", "none");
      $(".toggle-compare_at_price-gold-club").css("display", "");
      $(".toggle-product-label-savings-normal").css("display", "");
      $(".toggle-product-item__label-gold").css("display", "none");
      $('.product-card__redesign').attr('data-gourmet-club', 'false');
    }
  });
}


function updateMiniCartDiscount() {
  getDiscount().then(function (discountResponse) {    
    if (discountResponse) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          let discountValue = cart.total_discount / 100;
          const shopCurrency = window.theme.shopCurrency;
          const discountCodeText = discountResponse.code;
          const discountCodeTextLowerCase = discountCodeText.toLowerCase();
          const isGC = discountCodeTextLowerCase.includes("gc");
          let cartTotalPrice  = cart.total_price;

          if (discountValue == 0) {
            if (!!discountResponse.greaterThanOrEqualToSubtotal) {
              let requiredAmountDiscount = Number(discountResponse.greaterThanOrEqualToSubtotal) * 100;
              if (cart.original_total_price >= requiredAmountDiscount) {
                if (discountResponse.percentageValue) {
                  let discountPercantage =  Number(discountResponse.percentageValue);
                  discountValue = (cart.original_total_price / 100) * discountPercantage;
                } else if (discountResponse.fixedValue) {
                  discountValue = Number(discountResponse.fixedValue);
                }
              }
            }else {
              if (discountResponse.percentageValue) {
                let discountPercantage =  Number(discountResponse.percentageValue);
                discountValue = (cart.original_total_price / 100) * discountPercantage;
              } else if (discountResponse.fixedValue) {
                discountValue = Number(discountResponse.fixedValue);
              }
            }
          }
          if (cart.total_discount != (discountValue * 100) && discountValue !== 0) {
            cartTotalPrice = cartTotalPrice - (discountValue * 100);
          }else {
            cartTotalPrice = cart.total_price;
          }
          
          if (isGC) {
            // Show elements for gold club
            if (document.querySelectorAll(".toggle-product-item__label-gold")) {
              document.querySelectorAll(".toggle-product-item__label-gold").forEach(el => el.style.display = "");
            }
            if (document.querySelectorAll(".cart-toggle-price__gold-club")) {
              document.querySelectorAll(".cart-toggle-price__gold-club").forEach(el => el.style.display = "");
            }
            if (document.querySelectorAll(".cart-toggle-price__normal")) {
              document.querySelectorAll(".cart-toggle-price__normal").forEach(el => el.style.display = "none");
            }
          }
          if(document.querySelector(".mini-cart__discount-toggle")){
            document.querySelector(".mini-cart__discount-toggle").style.display = "";
          }
          if(document.getElementById("mini-cart-discount-code")){
            document.getElementById("mini-cart-discount-code").innerHTML = discountCodeText;
          }

          if (shopCurrency === 'CZK') {
            if (document.getElementById("mini-cart-discount-value")) {
              document.getElementById("mini-cart-discount-value").innerHTML = "-" + parseFloat(discountValue).toFixed(2).replace(".", ",") + " Kč";
            }
          } else {
            if(document.getElementById("mini-cart-discount-value")){
              document.getElementById("mini-cart-discount-value").innerHTML = "-" + parseFloat(discountValue).toFixed(2).replace(".", ",") + " &euro;";
            }
          }

          const shippingElement = document.getElementById("mini-cart-shipping-value");
          const shippingThreshold = parseInt(shippingElement?.dataset.defaultShippingThreshold);
          let shippingCost = parseInt(shippingElement?.dataset.defaultShippingCost); 
          
          if (discountResponse.isShippingDiscountCode) {
            shippingCost = 0;
            if(document.querySelector(".mini-cart__shipping")) {
              document.querySelector(".mini-cart__shipping").classList.add("shippingDiscountMini");
            }
          }

          if (shopCurrency === 'CZK') {
            if (cartTotalPrice < shippingThreshold) {
              if(shippingElement) {
                shippingElement.innerHTML = parseFloat(shippingCost / 100).toFixed(2) + " Kč";
              }
              if(document.getElementById("mini-cart-total-value")) {
                document.getElementById("mini-cart-total-value").innerHTML = parseFloat((cartTotalPrice + shippingCost) / 100).toFixed(2) + " Kč";
              }
            } else {
              if(document.getElementById("mini-cart-total-value")){
                document.getElementById("mini-cart-total-value").innerHTML = parseFloat(cartTotalPrice / 100).toFixed(2).replace(".", ",") + " Kč";
              }
            }
          } else {
            if (cartTotalPrice < shippingThreshold) {
              if(shippingElement){
                shippingElement.innerHTML = parseFloat(shippingCost / 100).toFixed(2) + " &euro;";
              }
              if(document.getElementById("mini-cart-total-value")){
                document.getElementById("mini-cart-total-value").innerHTML = parseFloat((cartTotalPrice + shippingCost) / 100).toFixed(2) + " &euro;";
              }
            } else {
              if(document.getElementById("mini-cart-total-value")){
                document.getElementById("mini-cart-total-value").innerHTML = parseFloat(cartTotalPrice / 100).toFixed(2).replace(".", ",") + " &euro;";
              }
            }
          }
        });
    } else {
      if(document.querySelector(".mini-cart__discount-toggle")){
        document.querySelector(".mini-cart__discount-toggle").style.display = "none";
      }
    }
  });
}


var closeAllPicker = function () {
  $(".js-value-picker").map(function () {
    $(".value-picker-button--border").attr("aria-expanded", "false");
    $(".value-picker").attr("aria-hidden", "true");
    return true;
  });
};

function Modal(root) {
  this.root = $(root);
  this.root.find(".modal__close, .button--close").on(
    "click",
    function () {
      this.close();
    }.bind(this)
  );
};

Modal.prototype = {
  open: function (data) {
    console.log(data)
    if (data) {
      var _this = this;
      Object.keys(data).map(function (key) {
        _this.root.find("[data-" + key + "]").html(data[key]);
      });
    }
    this.root.addClass("modal__visible");
  },
  close: function () {
    this.root.removeClass("modal__visible");
    if (this.onClose) {
      this.onClose();
    }
  },
};

function Scroller(root){
  this.root = $(root);
  var elements = [];
  this.root.children().each(function () {
    elements.push($(this));
    $(this).remove();
  });
  this.root.css("position", "relative");
  this.containerWidth = 0;
  this.contentWidth = 0;
  this.markerId = "marker_" + this.root.prop("id");

  this.scrollLeft = function () {
    var currentPos = parseInt(this.scrollContent.css("left").replace("px", ""));
    var totalWidth = $("#" + this.markerId).position().left;
    if (totalWidth <= this.containerWidth) {
      return;
    }
    var nextPos = currentPos + this.containerWidth;
    if (nextPos > 0) {
      nextPos = 0;
      this.root.find(".prev").removeClass("enabled");
      this.enableRightScrollControl();
    }
    this.scrollContent.animate({
      left: nextPos,
    });
  };

  this.scrollRight = function () {
    var currentPos = parseInt(this.scrollContent.css("left").replace("px", ""));
    var totalWidth = $("#" + this.markerId).position().left;
    if (totalWidth <= this.containerWidth) {
      return;
    }
    var nextPos = currentPos - this.containerWidth;
    if (totalWidth - Math.abs(nextPos) < this.containerWidth) {
      nextPos = -1 * (totalWidth - this.containerWidth);
      this.root.find(".next").removeClass("enabled");
      this.root.find(".prev").addClass("enabled");
    }
    this.scrollContent.animate({
      left: nextPos,
    });
  };

  this.enableRightScrollControl = function () {
    var totalWidth = $("#" + this.markerId).position().left;
    if (totalWidth > this.containerWidth) {
      this.root.find(".next").addClass("enabled");
    }
  };

  function applyChildren() {



    this.root.children().remove();
    this.root.css("width", "auto");
    this.containerWidth = $(root).parent().width();
    // $(root).css('width', this.containerWidth + 'px')
    // console.log(this.containerWidth)
    // $(root).css('overflow','auto')

    this.inner = $('<div class="scroll-inner">');
    this.inner.css("height", "100%");
    this.inner.css("width", "100%");
    this.root.append(this.inner);

    this.scrollContent = $('<div class="scroll-content">');
    this.scrollContent.css("display", "flex");
    this.scrollContent.css("position", "relative");
    this.scrollContent.css("background-color", "rgba(0,0,0,0.1)");
    this.contentWidth = 0;
    elements.forEach(
      function (item) {
        item.css("flex-shrink", "0");
        this.scrollContent.append(item);
      }.bind(this)
    );
    var marker = $('<div id="' + this.markerId + '"></div>');
    this.scrollContent.append(marker);
    this.scrollContent.css("width", this.contentWidth + "px");
    this.inner.append(this.scrollContent);

    var next = $(
      '<div class="scroller-next-prev next"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>'
    );
    if (!!next) {
      next.css("position", "absolute");
      next.css("right", "-15px");
      next.css("top", "calc(50% - 15px)");
      next.on("click", this.scrollRight.bind(this));
      this.inner.append(next);
    }

    var prev = $(
      '<div class="scroller-next-prev prev"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></div>'
    );
    if (!!prev) {
      prev.css("position", "absolute");
      prev.css("left", "-15px");
      prev.css("top", "calc(50% - 15px)");
      prev.on("click", this.scrollLeft.bind(this));
      this.inner.append(prev);
    }
    this.enableRightScrollControl();
  }

  applyChildren.bind(this)();

  this.refresh = function () {
    applyChildren.bind(this)();
  };

  $(window).resize(
    function () {
      applyChildren.bind(this)();
      document.dispatchEvent(new Event('scroller-resized'))
    }.bind(this)
  );
};

function IsInViewport (el) {
  if (typeof jQuery === "function" && el instanceof jQuery) el = el[0];
  var rect = el.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};
function  hideStickyCta(){
  if (!!$('.cart-recap__line--sticky')) {  
    if(screen.width <= 640 ){
      $(window).scroll(function() {
        if(!!$('.cart-section--recap__line')){
          if( IsInViewport($('.cart-section--recap__line')) ){
            $('.cart-recap__line--sticky').hide();
          } else {
            $('.cart-recap__line--sticky').show();
          }
        }
      });
    }
  }
}


$(document).ready(function () {
  var toggle = function (scope) {
    var el = $(scope).parent(".js-value-picker");
    var hidden = el.find(".value-picker").attr("aria-hidden");
    if (hidden === "true") {
      closeAllPicker();
      $(scope).on("focusout", function (event) {
        var parent = event.relatedTarget;
        if (parent != null) {
          parent = parent.parentElement.className;
          if (
            parent != "value-picker__use-selection-btn" &&
            parent != "value-picker__choice-list" &&
            parent != "value-picker__search-input"
          ) {
            $(scope).off("focusout");
            closeAllPicker();
          }
        } else {
          $(scope).off("focusout");
          closeAllPicker();
        }
      });
      el.find('[data-action="open-value-picker"]').attr(
        "aria-expanded",
        "true"
      );
      el.find(".value-picker").attr("aria-hidden", "false");
    } else {
      $(document).off(".valuePicker");
      el.find(".value-picker").attr("aria-expanded", "false");
      el.find(".value-picker").attr("aria-hidden", "true");
    }
  };
  $("#spr-mobile-btn").click(function () {
    $("html,body").animate(
      {
        scrollTop: $(".spr-form").offset().top - 170,
      },
      "slow"
    );
  });

  $(document).on(
    "click",
    '[data-action="open-vicampo-filter"][aria-controls="vicampo-second-filter"]',
    function (elem) {
      var statusFilter = $("#vicampo-second-filter").attr("aria-hidden");
      if (statusFilter == "true") {
        document
          .querySelector(
            '[data-action="open-vicampo-filter"][aria-controls="vicampo-second-filter"]'
          )
          .setAttribute("aria-expanded", "true");
        $("#vicampo-second-filter").attr("aria-hidden", "false");
      } else {
        document
          .querySelector(
            '[data-action="open-vicampo-filter"][aria-controls="vicampo-second-filter"]'
          )
          .setAttribute("aria-expanded", "false");
        $("#vicampo-second-filter").attr("aria-hidden", "true");
      }
    }
  );

  $(".spr-reviews").bind("DOMSubtreeModified", function () {
    if (
      $(".spr-rating-number").length == 0 &&
      $('meta[itemprop="ratingValue"]').attr("content")
    ) {
      $(".spr-summary")
        .children()
        .first()
        .prepend(
          '<span class="spr-rating-number">' +
            $('meta[itemprop="ratingValue"]')
              .attr("content")
              .replace(".", ",") +
            "</span>"
        );
    }
  });

  // $('.value-picker-button--border').on('click',function(){
  //   toggle(this);
  // })

  //close all picker if search
  $(".value-picker__use-selection-btn").on("click", function () {
    closeAllPicker();
  });

  $(".value-picker__search-input").keyup(function (event) {
    var inputId = event.target.id;
    var filter = document.querySelector("#" + inputId).value.toUpperCase();
    var parent = event.target.parentNode.parentNode.parentNode;
    var buttonList = parent.querySelector(".value-picker__choice-list")
      .children;
    for (var index = 0; index < buttonList.length; index++) {
      if (buttonList[index].innerText.toUpperCase().indexOf(filter) > -1) {
        buttonList[index].setAttribute("style", "display:block");
      } else {
        buttonList[index].setAttribute("style", "display:none");
      }
    }
  });

  $(".js-countdown-timer").each(function () {
    var $this = $(this);
    // Set the date we're counting down to
    var countDownDate = new Date($this.data("date")).getTime();

    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element with id="demo"
      $this.text(
        days +
          " " +
          languages.days +
          " " +
          hours +
          " " +
          languages.hours +
          " " +
          minutes +
          " " +
          languages.minutes +
          " " +
          seconds +
          " " +
          languages.seconds +
          " "
      );

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        $this.text(languages.expired);
      }
    }, 1000);
  });

  /**
   *
   * Notifications for discounts or marketing
   * See header.liquid
   * They use different triggers such as paramter or discount cookie
   */
});

function shouldShowBanner(id) {
  if (sessionStorage.getItem("banner-" + id) !== "no") {
    return true;
  }
  return false;
}

function setBannerShouldShow(id, shouldShow) {
  sessionStorage.setItem("banner-" + id, shouldShow ? "yes" : "no");
}

function handleInfoBanners(){
  if (document.querySelectorAll(".js-info-banner").length) {
    document.querySelectorAll(".js-info-banner").forEach(banner => {
      const discountCookie = getCookie("discount_code");
      const trigger = banner.dataset.trigger;
      const value = banner.dataset.value;
      const id = banner.dataset.id;
      if (!shouldShowBanner(id)) return;
  
      const showBanner = () => {
        banner.classList.remove("hidden");
        setTimeout(() => {
          banner.style.opacity = "1";
        }, 1300);
      };
  
      if (trigger) {
        switch (trigger) {
          case "static":
            if (!discountCookie) showBanner();
            break;
          case "no-discount":
            if (!discountCookie) showBanner();
            break;
          case "discount-gold-club":
            getDiscount().then(function (discountCode) {
              if (discountCode && discountCode.code.substring(0, 2).toLowerCase() === "gc") {
                if (banner.querySelector(".text")) {
                  const textElem = banner.querySelector(".text");
                  textElem.innerHTML = textElem.innerHTML.replace("{{DISCOUNT}}", `<b>${discountCode.code}</b>`);
                  showBanner();
                }
              }
            });
            break;
          case "discount":
            if (discountCookie && (!getCookie("voucher_form_submitted") || discountCookie != getCookie("voucher_form_submitted"))) {
              getDiscount().then(discountResult => {
                if (discountResult) {
                  if(discountResult.code.substring(0, 2).toLowerCase() !== "gc"){
                    if (banner.querySelector(".text")) {
                      const textElem = banner.querySelector(".text");
                      let isMissingAmount = false;
                      let missingAmount = 0;
                      let requiredAmount = 0;
    
                      if ((!!discountResult.greaterThanOrEqualToSubtotal && !!textElem.getAttribute('data-missing-amount-text')) || (!!discountResult.greaterThanOrEqualToQuantity && !!textElem.getAttribute('data-missing-quantity-text'))) {
                        isMissingAmount = true
                      }

                      if (isMissingAmount) {
                        fetch('/cart.js').then(response => response.json())
                        .then(cart => {
                          if (cart.item_count === 0) {
                            replaceValues(textElem, discountResult);

                          }else {
                            if (!!discountResult.greaterThanOrEqualToSubtotal) {
                              requiredAmount = Number(discountResult.greaterThanOrEqualToSubtotal) * 100;
                              if (requiredAmount > cart.original_total_price) {
                                missingAmount = requiredAmount - cart.original_total_price;
                                textElem.innerHTML = textElem.getAttribute('data-missing-amount-text').replace("{{MISSING_AMOUNT}}", `<b>${ formatMoney(missingAmount, window.theme.moneyFormat)}</b>` );
  
                                if (document.getElementById('info-banner-progress')) {
                                  const infoBannerProgress = document.getElementById('info-banner-progress');
                                  let missingPercentage = 100 - ((missingAmount / requiredAmount) * 100);
                                  infoBannerProgress.querySelector('#progress-bar-info').style.width = missingPercentage + "%";
                                  infoBannerProgress.classList.remove("hidden");
                                }
                              }else {
                                replaceValues(textElem, discountResult)
                              }
                            }
                            if (!!discountResult.greaterThanOrEqualToQuantity) {
                              requiredAmount = Number(discountResult.greaterThanOrEqualToQuantity);
                              if (requiredAmount > cart.item_count) {
                                missingAmount = requiredAmount - cart.item_count;
                                textElem.innerHTML = textElem.getAttribute('data-missing-quantity-text').replace("{{MISSING_QUANTITY}}", `<b>${missingAmount} ${missingAmount > 1 ? window.languages.product_count.more : window.languages.product_count.one}</b>` );
                                if (document.getElementById('info-banner-progress')) {
                                  const infoBannerProgress = document.getElementById('info-banner-progress');
                                  let missingPercentage = 100 - ((missingAmount / requiredAmount) * 100);
                                  infoBannerProgress.querySelector('#progress-bar-info').style.width = missingPercentage+ "%";
                                  infoBannerProgress.classList.remove("hidden");
                                }
                              } else {
                                replaceValues(textElem, discountResult)
                              }
                            }
                          }
                        })
                      }else {
                        replaceValues(textElem, discountResult)
                      }

                      function replaceValues(textElem, discountResult) {
                        if (textElem.getAttribute('data-active-text')) {
                          let updatedText = textElem.getAttribute('data-active-text');
                          updatedText = updatedText.replace('{{DISCOUNT}}', `<b>${discountResult.code}</b>`);
                          if (discountResult.percentageValue) {
                            updatedText = updatedText.replace('{{DISCOUNT_AMOUNT}}', `<b>${Number(discountResult.percentageValue) * 100}%</b>`);
                          } else if (discountResult.fixedValue) {
                            const formattedValue = formatMoney(Number(discountResult.fixedValue) * 100, window.theme.moneyFormat);
                            updatedText = updatedText.replace('{{DISCOUNT_AMOUNT}}', formattedValue ? `<b>${formattedValue}</b>` : '');
                          } else {
                            updatedText = updatedText.replace('{{DISCOUNT_AMOUNT}}', '');
                          }
                          textElem.innerHTML = updatedText;
                        }

                        if (document.getElementById('info-banner-progress')) {
                          document.getElementById('info-banner-progress').classList.add("hidden");
                        }
                      }
                      showBanner();
                    }
                  }
                }
              });
            }
            break;
          case "voucher_form":
            getDiscount().then(discountResult => {
              if (discountResult == false && !getCookie("voucher_form_submitted") && !getCookie("discount_code")) {
                if (banner.querySelector('.info-banner-container--inactive')) {
                  banner.querySelector('.info-banner-container--inactive').classList.remove("hidden");
                }
                if (banner.querySelector('.info-banner-container--active')) {
                  banner.querySelector('.info-banner-container--active').classList.add("hidden");
                }
                const button = document.querySelector('.info-banner-button');
                if (button) {
                  button.addEventListener('click', () => {
                    const popup = document.querySelector('[data-popup-type="voucher_form"]');
                    if (popup) popup.setAttribute('aria-hidden', false);
                  });
                }
              
                const closeButton = document.querySelector('.voucher-form__close');
                if (closeButton) {
                  closeButton.addEventListener('click', () => {
                    const popup = document.querySelector('[data-popup-type="voucher_form"]');
                    if (popup) popup.setAttribute('aria-hidden', true);
                  });
                }
                showBanner();
              } else if (
                (discountResult != false &&
                discountResult.code &&
                discountResult.code.substring(0, 2).toLowerCase() !== "gc") ||
                (!!getCookie("discount_code") || !!getCookie("voucher_form_submitted"))
              ) {
                const bannerDiscountResult = discountResult != false && discountResult.code
                  ? discountResult
                  : { code: getCookie("discount_code") || getCookie("voucher_form_submitted") };
                if (bannerDiscountResult.code && bannerDiscountResult.code.substring(0, 2).toLowerCase() === "gc") {
                  return;
                }
                if (banner.querySelector('.info-banner-container--inactive')) {
                  banner.querySelector('.info-banner-container--inactive').classList.add("hidden");
                }
                if (banner.querySelector('.info-banner-container--active')) {
                  let containerActive = banner.querySelector('.info-banner-container--active')
                  containerActive.classList.remove("hidden");
  
                  if (banner.querySelector(".text--active")) {
                    const textElem = banner.querySelector(".text--active");
                    let isMissingAmount = false;
                    let missingAmount = 0;
                    let requiredAmount = 0;
  
                    if ((!!bannerDiscountResult.greaterThanOrEqualToSubtotal && !!textElem.getAttribute('data-missing-amount-text')) || (!!bannerDiscountResult.greaterThanOrEqualToQuantity && !!textElem.getAttribute('data-missing-quantity-text'))) {
                      isMissingAmount = true
                    }
                    if (isMissingAmount) {
                      fetch('/cart.js').then(response => response.json())
                      .then(cart => {
                        if (cart.total_discount > 0 || cart.cart_level_discount_applications?.length > 0) {
                          replaceValues(textElem, bannerDiscountResult);
                          showBanner();
                          return;
                        }
                        if (cart.item_count === 0) {
                          replaceValues(textElem, bannerDiscountResult);
                        }else {
                          if (!!bannerDiscountResult.greaterThanOrEqualToSubtotal) {
                            requiredAmount = Number(bannerDiscountResult.greaterThanOrEqualToSubtotal) * 100;
                            if (requiredAmount > cart.original_total_price) {
                              missingAmount = requiredAmount - cart.original_total_price;
                              textElem.innerHTML = textElem.getAttribute('data-missing-amount-text').replace("{{MISSING_AMOUNT}}", `<b>${ formatMoney(missingAmount, window.theme.moneyFormat)}</b>` );
                              if (document.getElementById('voucher-banner-progress')) {
                                const infoBannerProgress = document.getElementById('voucher-banner-progress');
                                let missingPercentage = 100 - ((missingAmount / requiredAmount) * 100);
                                infoBannerProgress.querySelector('#voucher-progress-bar').style.width = missingPercentage + "%";
                                infoBannerProgress.classList.remove("hidden");
                              }
                              if (containerActive.querySelector('.icon--check-circle')) {
                                containerActive.querySelector('.icon--check-circle').classList.add("hidden");
                              }
                            }else {
                              replaceValues(textElem, bannerDiscountResult)
                            }
                          }
                    
                          if (!!bannerDiscountResult.greaterThanOrEqualToQuantity) {
                            requiredAmount = Number(bannerDiscountResult.greaterThanOrEqualToQuantity);
                            if (requiredAmount > cart.item_count) {
                              missingAmount = requiredAmount - cart.item_count;
                              textElem.innerHTML = textElem.getAttribute('data-missing-quantity-text').replace("{{MISSING_QUANTITY}}", `<b>${missingAmount} ${missingAmount > 1 ? window.languages.product_count.more : window.languages.product_count.one}</b>` );
                              if (document.getElementById('voucher-banner-progress')) {
                                const infoBannerProgress = document.getElementById('voucher-banner-progress');
                                let missingPercentage = 100 - ((missingAmount / requiredAmount) * 100);
                                infoBannerProgress.querySelector('#voucher-progress-bar').style.width = missingPercentage+ "%";
                                infoBannerProgress.classList.remove("hidden");
                              }
                              if (containerActive.querySelector('.icon--check-circle')) {
                                containerActive.querySelector('.icon--check-circle').classList.add("hidden");
                              }
                            } else {
                              replaceValues(textElem, bannerDiscountResult)
                            }
                          }
                        }
                        showBanner();
                      })
                    }else {
                      replaceValues(textElem, bannerDiscountResult);
                      showBanner();
                    }
                    
                    function replaceValues(textElem, discountResult) {
                      if (textElem.getAttribute('data-active-text')) {
                        let updatedText = textElem.getAttribute('data-active-text');
                        updatedText = updatedText.replace('{{DISCOUNT}}', `<b>${discountResult.code}</b>`);
                        if (discountResult.percentageValue) {
                          updatedText = updatedText.replace('{{DISCOUNT_AMOUNT}}', `<b>${Number(discountResult.percentageValue) * 100}%</b>`);
                        } else if (discountResult.fixedValue) {
                          const formattedValue = formatMoney(Number(discountResult.fixedValue) * 100, window.theme.moneyFormat);
                          updatedText = updatedText.replace('{{DISCOUNT_AMOUNT}}', formattedValue ? `<b>${formattedValue}</b>` : '');
                        } else {
                          updatedText = updatedText.replace('{{DISCOUNT_AMOUNT}}', '');
                        }
                        textElem.innerHTML = updatedText;
                      }
  
                      if (containerActive.querySelector('.icon--check-circle')) {
                        containerActive.querySelector('.icon--check-circle').classList.remove("hidden");
                      }
                      if (document.getElementById('voucher-banner-progress')) {
                        document.getElementById('voucher-banner-progress').classList.add("hidden");
                      }
                    }
                    showBanner();
                  }
                }
              }
            });
            break;
          default:
            if ((window.location.pathname === trigger || window.location.search.includes(trigger)) && discountCookie) {
              if (trigger === 'discount') {
                getDiscount().then(discountResult => {
                  if (discountResult) {
                    if(discountResult.code.substring(0, 2).toLowerCase() !== "gc"){
                      if (banner.querySelector(".text")) {
                        const textElem = banner.querySelector(".text");
                        textElem.innerHTML = textElem.innerHTML.replace("{{DISCOUNT}}", `<b>${discountResult.code}</b>`);
                        if (discountResult.percentageValue) {
                          textElem.innerHTML = textElem.innerHTML.replace('{{DISCOUNT_AMOUNT}}', `<b>${discountResult.percentageValue * 100}%</b>`);
                        } else if (discountResult.fixedValue) {
                          const formattedValue = formatMoney(Number(discountResult.fixedValue) * 100, window.theme.moneyFormat);
                          textElem.innerHTML = textElem.innerHTML.replace('{{DISCOUNT_AMOUNT}}', formattedValue ? `<b>${formattedValue}</b>` : '');
                        } else {
                          textElem.innerHTML = textElem.innerHTML.replace('{{DISCOUNT_AMOUNT}}', '');
                        }
                        showBanner();
                      }
                    }
                  }
                });
              } else {
                showBanner();
              }
            }
            break;
        }
      } else {
        showBanner();
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function (event) {
  // Close icon click handler
  document.querySelectorAll(".js-info-banner .icon-close").forEach(closeIcon => {
    closeIcon.addEventListener("click", () => {
      const banner = closeIcon.closest(".js-info-banner");
      banner.classList.add("hidden");
      const id = banner.dataset.id;
      setBannerShouldShow(id, false);
    });
  });

  var pageType = window.theme.pageType
  if (pageType == 'cart') {
    hideStickyCta()
  }
  if (!!getCookie("discount_code")) {
    const discountCode = getCookie("discount_code");
    const voucherCode = getCookie("voucher_form_submitted");
    if (!voucherCode || voucherCode.toLowerCase() !== discountCode.toLowerCase()) {
      setCookie("voucher_form_submitted", discountCode, 365);
    }
  }
  
  handleInfoBanners()
})

document.addEventListener('theme:loading:end', function (event) {
  handleInfoBanners()
})

document.addEventListener('discount:valid', function () {
  handleInfoBanners()
})

document.addEventListener('cart:rerendered', function () {
  handleInfoBanners()
})

document.addEventListener('product:added', function () {
  handleInfoBanners()
})


function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  var value = '';

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }

  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value).replace(',00', '');
  } else {
    return formatString.replace(placeholderRegex, value).replace('.00', '');
  }
}

document.addEventListener("DOMContentLoaded",function (e) {switchGoldClubPricing()});
document.addEventListener("cart:rerendered", function (e) {
  switchGoldClubPricing();
  if(window.theme.template != 'cart'){
    updateMiniCartDiscount();
  }
});

document.addEventListener( "theme:loading:end",function (e) {
  switchGoldClubPricing();
},false);


document.addEventListener("recommendations:loaded", function (e) {
  switchGoldClubPricing();
});
// functions to detect touch in producte image or title or price in collection to swapping between two photos 


function imgTouchStart(e){


 $($(e.target)[0]).fadeOut(300);
 $( $(e.target)[0].nextSibling).fadeIn(300);

}

 function imgTouchEnd(e){
  $($(e.target)[0]).fadeIn(300);
  $( $(e.target)[0].nextSibling).fadeOut(300)

   } 


    function infoTouchStart(ev){

       $($(ev.target.offsetParent).find(".product-item__primary-image")[0]).fadeOut(300)
     $($(ev.target.offsetParent).find(".product-item__secondary-image")[0]).fadeIn(300)

  
    }
    
    function infoTouchEnd(ev){
    
       $($(ev.target.offsetParent).find(".product-item__primary-image")[0]).fadeIn(300)
       $($(ev.target.offsetParent).find(".product-item__secondary-image")[0]).fadeOut(300)

    }

    function priceTouchStart(ev){
      $($(ev.target.offsetParent.offsetParent).find(".product-item__primary-image")[0]).fadeOut(300)
      $($(ev.target.offsetParent.offsetParent).find(".product-item__secondary-image")[0]).fadeIn(300)
     }
    function priceTouchEnd(ev){

      $($(ev.target.offsetParent.offsetParent).find(".product-item__primary-image")[0]).fadeIn(300)
      $($(ev.target.offsetParent.offsetParent).find(".product-item__secondary-image")[0]).fadeOut(300)
    }


   
//go-top function
var goTop = $('.go-top');
var lastScrollTop = 0;
    if (goTop != null) {
      
   
    $(function(){

      //Scroll event
      $(window).scroll(function(){
        var st = $(this).scrollTop();
        if (st < lastScrollTop){$('.go-top').fadeIn(400);}
        if (st > lastScrollTop){$('.go-top').fadeOut(400);}
        lastScrollTop = st;
        if (st == 0){$('.go-top').fadeOut(400);}
     
      });
      
      //Click event
      $('.go-top').click(function () {
        $("html, body").animate({ scrollTop: "0" }, 500);});
    });

  }

function checkForSovendus() {
  const currentUrl = window.location.href;

  if (currentUrl.includes('sovReqToken=')) {
    const sovReqTokenValue = currentUrl.match(/sovReqToken=([^&?#]*)/);

    if (sovReqTokenValue) {
      console.log('Found sovReqToken:', sovReqTokenValue[1]);
      setSovReqTokenWithExpiration('sovReqToken', sovReqTokenValue[1], 4 * 60 * 60);
    }
  }
}
  
function setSovReqTokenWithExpiration(key, value, expirationInSeconds) {
  const expirationTime = new Date(Date.now() + expirationInSeconds * 1000).toUTCString();
  document.cookie = key + '=' + value + '; expires=' + expirationTime + '; path=/';
}

window.addEventListener('load', checkForSovendus);